import { fetchWrapper } from "../../helpers/fetch.wrapper";

const baseUrl = `${process.env.REACT_APP_BASE_URL}/compare`;

export const compareService = {
    createBySource,
    updateBySource,
    deleteBySource,
    getAllSources,
    compareSources,
    updateAll,
    getActivityLogs,
    mergeDuplicates,
    deleteKlaviyoDuplicate
};

async function createBySource(compareRequest) {
    return fetchWrapper.post(`${baseUrl}`, compareRequest)
        .then(response => response);
}

async function updateBySource(id, compareRequest) {
    return fetchWrapper.put(`${baseUrl}/${id}`, compareRequest)
        .then(response => response);
}

async function deleteBySource(id, source) {
    return fetchWrapper.delete(`${baseUrl}/${id}?source=${encodeURIComponent(source)}`)
        .then(response => response);
}

async function getAllSources(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`)
        .then(response => response);
}

async function compareSources(compareRequest) {
    return fetchWrapper.post(
        `${baseUrl}/compare`,
        compareRequest
    )
        .then(response => response);
}

async function updateAll(saveRequest) {
    return fetchWrapper.post(
        `${baseUrl}/update-all`,
        saveRequest
    )
        .then(response => response);
}

async function getActivityLogs(params = {}) {
    const query = new URLSearchParams(params).toString();
    return fetchWrapper.get(
        `${baseUrl}/activity?${query}`
    )
        .then(response => response);
}

async function mergeDuplicates({ customerId, source }) {
    return fetchWrapper.post(`${baseUrl}/duplicates/merge`, { customerId, source })
        .then(response => response);
}

async function deleteKlaviyoDuplicate(profileId, customerId) {
    return fetchWrapper.delete(`${baseUrl}/duplicates/klaviyo/${profileId}?customerId=${encodeURIComponent(customerId)}`)
        .then(response => response);
}
